import { render, staticRenderFns } from "./HistoricoAlteracoesRotasPainel.vue?vue&type=template&id=243a5676&scoped=true&"
import script from "./HistoricoAlteracoesRotasPainel.vue?vue&type=script&lang=js&"
export * from "./HistoricoAlteracoesRotasPainel.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoAlteracoesRotasPainel.vue?vue&type=style&index=0&id=243a5676&prod&scoped=true&lang=css&"
import style1 from "./HistoricoAlteracoesRotasPainel.vue?vue&type=style&index=1&id=243a5676&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a5676",
  null
  
)

export default component.exports